export default function FormBox({type ='text', label, placeholder, name, value, extra, onChange }){
    return <div className="form-item">
        <div className="form-label">{label}</div>
        <div className="form-input">
            <input autoComplete="off" type={type} className="input-inner" name={name} placeholder={placeholder} value={value} onChange={onChange}/>
            {extra}
        </div>
    </div>
}